/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { Component } from 'react';
// styles
import injectSheet from 'react-jss';
import styles from 'material/embeds/content/edit/correct/correct_styles';



/* ========== ~~~~~~~~~~ EMBED : EDIT : CORRECT ~~~~~~~~~~ ========== */
class Correct extends Component {
	constructor(props) {
		super(props);
		this.handleSetCorrectAnswer = this.handleSetCorrectAnswer.bind(this);
	}
	handleSetCorrectAnswer() {
		this.props.selectCorrectOption(this.props.optionId);
		// reset validation state when correct answer is selected
		if (!this.props.correctOptionSelected) { this.props.setQBProperty(this.props.contentId, 'correctOptionSelected', true) }
	}
	render() {
		if (this.props.contentType !== 'quiz') return null;
		return (
			<div className={`editorelement correct ${this.props.classes.correct} ${this.props.type} isValid-${this.props.correctOptionSelected} isCorrect-${this.props.correctOption}`} onClick={this.handleSetCorrectAnswer}>
				<div className={`icon`}><div className={`symbol`} /></div>
				<div className={`instruction`}>{this.props.correctOption ? 'Correct' : 'Set Correct'}</div>
			</div>
		);
	}
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(Correct);
